import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Paper, Typography, } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { throttle } from 'lodash';
import { useMutation } from "@tanstack/react-query";
import { patchProject } from "../../api/project-api.js";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const useThrottledNoteMutation = () => {
  const mutation = useMutation({
    mutationFn: ({ project, note }) => {
      return patchProject(project.id, {
        note
      });
    },
  });

  const mutate = useMemo(
    () => throttle(mutation.mutate, 500),
    [mutation.mutate]
  );

  return { ...mutation, mutate };
};

export const Help = () => {
  const { t } = useTranslation(["help", "common"]);

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: "flex", mb: 2 }}>
        <Typography variant="h5" sx={{ flex: 1 }}>
          {t("help")}
        </Typography>
      </Box>
      <Box>
        <Box>
          <Typography variant="h6" sx={{ mb: 2 }}>
            {t("userManual")}
          </Typography>
          <Typography variant="body1">
            A felhasználói kézikönyv részletes útmutatót nyújt az i-GIS mindennapi használatához. Ideális választás, ha gyors segítséget keres vagy szeretné mélyebben megismerni a szoftver funkcióit és lehetőségeit.
          </Typography>
          <Button component={"a"} href={"/Felhasználói kézikönyv.pdf"} target={"_blank"}
                  variant={"outlined"} sx={{ mt: 2, mb: 4 }}>Felhasználói kézikönyv</Button>

          <Typography variant="h6" sx={{ mb: 2 }}>
            {t("faq")}
          </Typography>
          <Paper>
            {[...Array(5).keys()].map(i =>
              <Accordion key={i}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon/>}
                >
                  <Typography component="span">Accordion {i + 1}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                    malesuada lacus ex, sit amet blandit leo lobortis eget.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            )}
          </Paper>

          <Typography variant="h6" sx={{ my: 2 }}>
            {t("videos")}
          </Typography>
          <Box sx={{ mb: 4 }}>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/99BMuvT-gZ8?si=dQ7by7CixubZZVJc"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen></iframe>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};
